module.exports = __webpack_public_path__ + "img/H4.2c68358f.png";